import React, { useState } from 'react';
import '../login.css';
import { showNotification } from '../utils/NotificationUtils';

const API_URL = process.env.REACT_APP_API_URL;

const Login = ({ handleLogin }) => {
  const [view, setView] = useState('login');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const getErrorMessage = async (response, fallback) => {
    const data = await response.json().catch(() => null);
    return data?.error || fallback;
  };

  const login = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await response.json().catch(() => null);

      if (!response.ok) {
        showNotification(data?.error || 'Usuário ou senha inválidos.', 'error');
        return;
      }

      localStorage.setItem('access_token', data.access_token);
      handleLogin(data.access_token);
    } catch (error) {
      console.error('Erro ao realizar login:', error);
      showNotification('Não foi possível realizar o login. Tente novamente.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const cadastrar = async (event) => {
    event.preventDefault();

    if (password !== confirmPassword) {
      showNotification('As senhas não coincidem.', 'error');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_URL}usuarios/cadastro`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, email, senha: password }),
      });

      if (!response.ok) {
        showNotification(await getErrorMessage(response, 'Não foi possível criar a conta.'), 'error');
        return;
      }

      setPassword('');
      setConfirmPassword('');
      setView('login');
      showNotification('Conta criada com sucesso. Faça login para continuar.', 'success');
    } catch (error) {
      console.error('Erro ao criar conta:', error);
      showNotification('Não foi possível criar a conta. Tente novamente.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const recuperarSenha = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}usuarios/recuperar-senha`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        showNotification(await getErrorMessage(response, 'Não foi possível solicitar a recuperação.'), 'error');
        return;
      }

      showNotification('Se houver uma conta para este e-mail, enviaremos as instruções de redefinição.', 'success', 5000);
      setView('login');
    } catch (error) {
      console.error('Erro ao recuperar senha:', error);
      showNotification('Não foi possível solicitar a recuperação. Tente novamente.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const voltarAoLogin = () => {
    setPassword('');
    setConfirmPassword('');
    setView('login');
  };

  return (
    <div className="login-container">
      <div id="notification-container" className='notification-container' style={{
        position: "fixed",
        display: "flex,",
        flexDirection: "column-reverse",
        justifyContent: "flex-end",
        flexWrap: "wrap-reverse",
        alignItems: "flex-end",
        bottom: "0,",
        right: "30px",
        maxHeight: "100vh"
      }}></div>

      <div className="login-box">
        {view === 'login' && (
          <>
            <h1>Login</h1>
            <form onSubmit={login}>
              <div className="input-group-login">
                <i className="fas fa-user" />
                <input value={username} type="text" placeholder="Usuário" autoComplete="username" onChange={(event) => setUsername(event.target.value)} required />
              </div>
              <div className="input-group-login">
                <i className="fas fa-lock" />
                <input value={password} type="password" placeholder="Senha" autoComplete="current-password" onChange={(event) => setPassword(event.target.value)} required />
              </div>
              <button className="add-button" type="submit" disabled={loading}>{loading ? 'Entrando...' : 'Login'}</button>
            </form>
            <div className="login-actions">
              <button type="button" className="login-link-button" onClick={() => setView('forgot')}>Esqueci minha senha</button>
              <button type="button" className="login-link-button" onClick={() => setView('register')}>Criar conta</button>
            </div>
          </>
        )}

        {view === 'register' && (
          <>
            <h1>Criar conta</h1>
            <p className="login-subtitle">Preencha seus dados para acessar o sistema.</p>
            <form onSubmit={cadastrar}>
              <div className="input-group-login">
                <i className="fas fa-user" />
                <input value={username} type="text" placeholder="Usuário" autoComplete="username" minLength="3" onChange={(event) => setUsername(event.target.value)} required />
              </div>
              <div className="input-group-login">
                <i className="fas fa-envelope" />
                <input value={email} type="email" placeholder="E-mail" autoComplete="email" onChange={(event) => setEmail(event.target.value)} required />
              </div>
              <div className="input-group-login">
                <i className="fas fa-lock" />
                <input value={password} type="password" placeholder="Senha (mínimo de 8 caracteres)" autoComplete="new-password" minLength="8" onChange={(event) => setPassword(event.target.value)} required />
              </div>
              <div className="input-group-login">
                <i className="fas fa-lock" />
                <input value={confirmPassword} type="password" placeholder="Confirmar senha" autoComplete="new-password" minLength="8" onChange={(event) => setConfirmPassword(event.target.value)} required />
              </div>
              <button className="add-button" type="submit" disabled={loading}>{loading ? 'Criando...' : 'Criar conta'}</button>
            </form>
            <button type="button" className="login-link-button login-back-button" onClick={voltarAoLogin}>Voltar para o login</button>
          </>
        )}

        {view === 'forgot' && (
          <>
            <h1>Recuperar senha</h1>
            <p className="login-subtitle">Informe seu e-mail e enviaremos um link para definir uma nova senha.</p>
            <form onSubmit={recuperarSenha}>
              <div className="input-group-login">
                <i className="fas fa-envelope" />
                <input value={email} type="email" placeholder="E-mail" autoComplete="email" onChange={(event) => setEmail(event.target.value)} required />
              </div>
              <button className="add-button" type="submit" disabled={loading}>{loading ? 'Enviando...' : 'Enviar instruções'}</button>
            </form>
            <button type="button" className="login-link-button login-back-button" onClick={voltarAoLogin}>Voltar para o login</button>
          </>
        )}
      </div>
    </div>
  );
};

export default Login;
